import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SparePartSearchSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}parts/searchFull`;

export interface SearchFullSparePartsQueryReturnValues {
  spareParts: SparePartSearchSummary[];
  bomDocuments: {
    url: string;
    name: string;
  }[];
  categories: string[];
  sparePartSuppliers: {
    id: string;
    companyName: string;
  }[];
}

export interface SearchFullSparePartsQueryArgs {
  sellerId: string;
  manufacturerReference?: string;
  supplierReference?: string;
  sparePartSupplierIds?: string[];
  factoryCode?: string;
  fileSku?: string;
  fileId?: string;
}

export async function searchFullSparePartsQuery({
  sellerId,
  manufacturerReference,
  supplierReference,
  sparePartSupplierIds,
  factoryCode,
  fileSku,
  fileId,
}: SearchFullSparePartsQueryArgs): Promise<
  BackResponse<SearchFullSparePartsQueryReturnValues> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<SearchFullSparePartsQueryReturnValues>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.POST,
        json: {
          sellerId,
          manufacturerReference,
          supplierReference,
          sparePartSupplierIds,
          factoryCode,
          fileSku,
          fileId,
        },
      },
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
